import { gql } from 'apollo-boost'

import useMutation, { mutationTypes } from '@utils/graphqlUtils'

const MUTATION = gql`
  mutation(
    $id: String!
    $data: FertilizerUpdateInput!
  ) {
    updateOneFertilizer(
      where: {
        id: $id
      }
      data: $data
    ) {
      id
    }
  }
`

export default () => (
  useMutation(MUTATION, `Fertilizante actualizado`, mutationTypes.UPDATE)
)

